import root from 'window-or-global';
import React, {useEffect, useState} from 'react';
import OAuth from './OAuth';
import oauthActions from '../../actions/oauth.actions';
import influencerActions from '../../actions/influencer.actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {RedirectWithParams} from 'epic-diesel-common';
import {LoadIndicator, Login} from '../../components';
import {OAuthState} from '../../reducers/oauth.reducer';
import {onResizePopupListener} from '../../utils/oauth';

import {
    canReactivate,
    canReApply,
    isActiveAffiliate,
    isNewApplicant
} from '../../utils/ValidationUtils';

const mapStateToProps = state => ({
    messages: state.get('localization').get('messageProperties'),
    userState: state.get('user').toJS(),
    influencerState: state.get('influencer').toJS(),
    configState: state.get('config').toJS(),
    oauthState: state.get('oauth').toJS()
});

const mapDispatchToProps = dispatch => ({
    getOAuth: (data?) => {
        dispatch(oauthActions.getOAuth(data));
    },
    updateOAuthChannel: (platform, selectedChannelId) => {
        dispatch(influencerActions.updateOAuthChannel({platform, selectedChannelId}));
    }
});

export interface OAuthViewProps {
    influencerState: any;
    userState: any;
    configState: any;
    messages: any;
    getOAuth: (data?) => void;
    oauthState: OAuthState;
    location: any;
    closePopup: () => void;
    updateOAuthChannel: (platform: string, selectedChannelId: string) => void;
}

const OAuthView: React.FC<OAuthViewProps> = props => {
    const [isPopup, setIsPopup] = useState<boolean>(true);
    const {accountInfo} = props.userState || {};
    const {isLoggedIn} = accountInfo;
    const {affiliateAccount} = props.influencerState || {};
    const {enableReactivation} = props.configState || {};

    useEffect(() => {
        if (root && !!root.opener === true) {
            onResizePopupListener(root);
            setIsPopup(true);
        }
    }, []);

    if (
        !isLoggedIn ||
        !(
            isNewApplicant(affiliateAccount) ||
            isActiveAffiliate(affiliateAccount) ||
            canReApply(affiliateAccount) ||
            (enableReactivation && canReactivate(affiliateAccount))
        )
    ) {
        return <RedirectWithParams to={`${root.appContext}/overview`} ignoreSearch />;
    }

    if (!isPopup) {
        return root && root.close();
    }

    const isLoading = props.oauthState.loading || props.influencerState.loading;
    return (
        <Login isLoggedIn={isLoggedIn}>
            <LoadIndicator isLoading={isLoading} messages={props.messages}>
                <OAuth {...props} closePopup={() => root.close()} />
            </LoadIndicator>
        </Login>
    );
};

export default compose<React.FC<OAuthViewProps>>(
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(OAuthView);
